'use client'

import CookieConsent, { Cookies } from "react-cookie-consent"
import Link from "next/link"

export function CookieBanner({ onConsentChange }: { onConsentChange: (consent: boolean) => void }) {

  const handleAccept = () => {
    Cookies.set("CookieConsent", "true", { expires: 365 })
    onConsentChange(true)
  }

  const handleDecline = () => {
    Cookies.set("CookieConsent", "false", { expires: 365 })
    onConsentChange(false)
  }

  return (
    <CookieConsent
      location="bottom"
      buttonText="Accept All"
      declineButtonText="Accept Necessary"
      enableDeclineButton
      expires={365}
      cookieName="CookieConsent"
      onAccept={handleAccept}
      onDecline={handleDecline}
      disableStyles={true}
      containerClasses="fixed bottom-0 w-full bg-zinc-200 px-8 py-8 flex flex-col md:flex-row justify-center md:justify-between items-center shadow-md z-50"
      contentClasses="text-zinc-800 text-[15px] font-light mb-4 md:mb-0"
      buttonClasses="bg-[#487AB7] text-white text-[14px] font-medium px-5 h-10 rounded-full hover:bg-[#3D69A0] transition duration-200"
      declineButtonClasses="bg-[#B54256] text-white text-[14px] font-medium px-5 h-10 rounded-full hover:bg-[#9F3A4C] transition duration-200 mr-4 md:mr-8"
      buttonWrapperClasses="p-0 m-0"
    >
      We use cookies for authentication and analytics.{" "}
      <Link href="/privacy-policy" className="text-[#487AB7] cursor-default">Learn more</Link>.
    </CookieConsent>
  )
}
